import { NgModule } from '@angular/core';
import { WizardBaseTabComponent } from './components/wizard-base-tab/wizard-base-tab.component';
import { WizardTabComponent } from './components/wizard-tab/wizard-tab.component';
import { WizardComponent } from './wizard.component';

@NgModule({
  imports: [WizardBaseTabComponent, WizardComponent, WizardTabComponent],
  exports: [WizardBaseTabComponent, WizardComponent, WizardTabComponent],
})
export class WizardModule {}
